var React = require('react');

function Buromobelexperte (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"}));
}

Buromobelexperte.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Buromobelexperte;

Buromobelexperte.default = Buromobelexperte;
